import { Routes } from '@angular/router';
import { DEFAULT_MODAL_ROUTE_CONFIG } from '@app/common/default-modal-route-config';
import { DefaultRoutes } from '@app/common/default-routes';

export const WPLIGHT_ROUTE_CONFIG: Routes = [
  DefaultRoutes.TODAY_LIGHT,
  DefaultRoutes.FIND_INFO_LIGHT,
  DefaultRoutes.TODAY_WITH_LICENSE_CHECK,
  DefaultRoutes.YOUR_BOARD_WITH_LICENSE_CHECK,
  DefaultRoutes.COLLABORATION_WITH_LICENSE_CHECK,
  DefaultRoutes.FIND_INFO_WITH_LICENSE_CHECK,
  DefaultRoutes.APPS_TOOLS,
  DefaultRoutes.SETTINGS,
  DefaultRoutes.CREATE_SITE,
  DefaultRoutes.EDITOR_DASHBOARD,
  DefaultRoutes.FIRST_DAY,
  DefaultRoutes.ADMIN,
  DefaultRoutes.ABOUT,
  DefaultRoutes.PEOPLE,
  DefaultRoutes.BROADCAST_MESSAGES,
  DefaultRoutes.RESTAURANT,
  DefaultRoutes.KPI_CHARTS,
  DefaultRoutes.MSTEAMS_AUTH,
  DefaultRoutes.INFOBOXES,
  DefaultRoutes.PAGES,
  {
    path: '**', redirectTo: ''
  },
  ...DEFAULT_MODAL_ROUTE_CONFIG
];
